// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetDivisionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetDivisionQuery = { __typename?: 'Query' } & {
  division: Types.Maybe<{ __typename?: 'Division' } & Pick<Types.Division, 'id' | 'name'>>;
};

export const GetDivisionDocument = /*#__PURE__*/ gql`
    query getDivision($id: ID!) {
  division(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetDivisionQuery__
 *
 * To run a query within a React component, call `useGetDivisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDivisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDivisionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDivisionQuery(
  baseOptions: Apollo.QueryHookOptions<GetDivisionQuery, GetDivisionQueryVariables> &
    ({ variables: GetDivisionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDivisionQuery, GetDivisionQueryVariables>(GetDivisionDocument, options);
}
export function useGetDivisionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDivisionQuery, GetDivisionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDivisionQuery, GetDivisionQueryVariables>(GetDivisionDocument, options);
}
// @ts-expect-error
export function useGetDivisionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDivisionQuery, GetDivisionQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDivisionQuery, GetDivisionQueryVariables>;
export function useGetDivisionSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivisionQuery, GetDivisionQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDivisionQuery | undefined, GetDivisionQueryVariables>;
export function useGetDivisionSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivisionQuery, GetDivisionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDivisionQuery, GetDivisionQueryVariables>(GetDivisionDocument, options);
}
export type GetDivisionQueryHookResult = ReturnType<typeof useGetDivisionQuery>;
export type GetDivisionLazyQueryHookResult = ReturnType<typeof useGetDivisionLazyQuery>;
export type GetDivisionSuspenseQueryHookResult = ReturnType<typeof useGetDivisionSuspenseQuery>;
